export const chartOptionsMixin = {
  data: function () {
    return {
      chartOptions: {
        id: "",
        chart: {
          type: this.chart,
          backgroundColor: "transparent",
        },
        exporting: {
          enabled: true,
        },
        title: {
          text: "",
          style: {
            color: "white",
            display: "",
          },
        },
        subtitle: {
          text:
          this.chartType != "spaceUtilization" ?
            (this.chart == "column"
              ? "Click on bars to view by product group"
              : "Click on piece to view by product group") : "",
          style: {
            color: "white",
            display: "",
          },
        },
        xAxis: {
          type: "category",
          labels: {
            style: {
              color: "white",
            },
          },
        },
        yAxis: {
          title: {
            text: "Percentage Of Total",
          },
          stackLabels: {
            enabled: false,
            formatter: function () {
              return "Total: " + this.total;
            },
            style: {
              fontWeight: "bold",
              color: "white",
            },
          },
        },
        legend: {
          enabled: this.chartType == "spaceUtilization",
        },
        tooltip: {
          headerFormat: this.chartType == "spaceUtilization" ? "" : '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>",
        },
        plotOptions: {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: false,
              formatter: function () {
                return "TEST";
              },
            },
          },
          series: {
            dataLabels: {
              enabled: this.chart == "column" ? false : true,
              format: "{point.name}: {point.y:.1f}%",
              color: "white",
              style: {
                textOutline: false,
              },
            },
            point: {
              events: {
                click: ({ point }) => {
                  if (this.isCompanyOverall) {
                    let name = point.name.split("(");
                    this.$router.push(
                      "/base/company-profile/?company=" +
                        name[0] +
                        "&date_from=" +
                        this.dateFrom +
                        "&date_to=" +
                        this.dateTo
                    );
                  } else if (this.model) {
                    this.$router.push(
                      "/base/Tables/?location=" +
                        point.name +
                        "&productModel=" +
                        this.modelName +
                        "%287%29" +
                        "&type=" +
                        this.chartType +
                        "&fns_part=" +
                        this.model +
                        (this.dateFrom ? "&date_from=" + this.dateFrom : "") +
                        (this.dateTo ? "&date_to=" + this.dateTo : "")
                    );
                  } else {
                    if (point.name) {
                      if (this.city) {
                        this.$router.push(
                          "/base/Tables/?location=" +
                            this.cityName +
                            "%287%29" +
                            "&productGroup=" +
                            point.series.name +
                            "%287%29" +
                            "&productModel=" +
                            point.name.substring(0, point.name.indexOf("(")) +
                            "%287%29" +
                            "&type=" +
                            this.chartType +
                            (this.city ? "&client=" + this.city : "") +
                            (this.equipment_status
                              ? "&equipment_status=" + this.equipment_status
                              : "") +
                            (this.productType
                              ? "&productType=" + this.productType
                              : "") +
                            "&date_from=" +
                            this.dateFrom +
                            "&date_to=" +
                            this.dateTo
                        );
                      } else if (this.units || this.recycled) {
                        this.$router.push(
                          "/base/Tables/?type=" +
                            point.series.name.toLowerCase() +
                            "-" +
                            point.name
                              .substring(0, point.name.indexOf("("))
                              .trimEnd()
                              .replace(/ /g, "-")
                              .toLowerCase() +
                            "&date_from=" +
                            this.dateFrom +
                            "&date_to=" +
                            this.dateTo
                        );
                      } else if (this.warrantyRepair) {
                        this.$router.push(
                          "/base/Tables/?type=" +
                            point.name
                              .substring(0, point.name.indexOf("("))
                              .trimEnd()
                              .replace(/ /g, "-")
                              .toLowerCase() +
                            "&date_from=" +
                            this.dateFrom +
                            "&date_to=" +
                            this.dateTo
                        );
                      } else if (this.tested) {
                        this.$router.push(
                          "/base/Tables/?type=" +
                            this.chartType +
                            "&productGroup=" +
                            point.name.substring(0, point.name.indexOf("(")) +
                            "&date_from=" +
                            this.dateFrom +
                            "&date_to=" +
                            this.dateTo +
                            (this.selectedProduct && this.selectedProduct.id
                              ? "&prodModel=" + this.selectedProduct.id
                              : "") +
                            (this.selectedManufacturer
                              ? "&thirdPartyClientId=" +
                                this.selectedManufacturer
                                  .map((manufacturer) => manufacturer.id)
                                  .join(",")
                              : "")
                        );
                      } else {
                        this.$router.push(
                          "/base/Tables/?location=" +
                            point.series.name +
                            "%287%29" +
                            "&productGroup=" +
                            point.name.substring(0, point.name.indexOf("(")) +
                            "%287%29" +
                            "&type=" +
                            this.chartType +
                            "&date_from=" +
                            this.dateFrom +
                            "&date_to=" +
                            this.dateTo +
                            (this.selectedProduct && this.selectedProduct.id
                              ? "&prodModel=" + this.selectedProduct.id
                              : "") +
                            (this.selectedManufacturer
                              ? "&thirdPartyClientId=" +
                                this.selectedManufacturer
                                  .map((manufacturer) => manufacturer.id)
                                  .join(",")
                              : "")
                        );
                      }
                    }
                  }
                },
              },
            },
          },
        },
        drilldown: {
          activeAxisLabelStyle: {
            textDecoration: "none",
            color: "white",
          },
          activeDataLabelStyle: {
            color: "white",
          },
        },
        series: [
          {
            name: "Locations",
            colorByPoint: true,
            data: null,
          },
        ],
      },
    };
  },
};
